import React from 'react'
import {Global} from '@emotion/react'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'

const LocalFonts = () => (
    <Global
        styles={`
            /* Helvetica Neue LT Std */
            @font-face {
                font-family: 'HelveticaNeueLTStd';
                font-style: normal;
                font-weight: 700;
                font-display: swap;
                src: url(${getAssetUrl(
                    'static/fonts/HelveticaNeueLTStd-Bd.woff2'
                )}) format('woff2');
                descent-override: 0%;
            }
            @font-face {
                font-family: 'HelveticaNeueLTStd';
                font-style: normal;
                font-weight: 500;
                font-display: swap;
                src: url(${getAssetUrl(
                    'static/fonts/HelveticaNeueLTStd-Md.woff2'
                )}) format('woff2');
                descent-override: 0%;
            }
            @font-face {
                font-family: 'HelveticaNeueLTStd';
                font-style: normal;
                font-weight: normal;
                font-display: swap;
                src: url(${getAssetUrl(
                    'static/fonts/HelveticaNeueLTStd-Roman.woff2'
                )}) format('woff2');
                descent-override: 0%;
            }

            /* Helvetica Neue LT Std - Form Elements */
            @font-face {
                font-family: 'HelveticaNeueLTStd-Form';
                font-style: normal;
                font-weight: normal;
                font-display: swap;
                src: url(${getAssetUrl(
                    'static/fonts/HelveticaNeueLTStd-Roman.woff2'
                )}) format('woff2');
            }

            input, textarea, select {
                font-family: 'GarageNeue', sans-serif;
            }

            /* Azo Sans */
            @font-face {
                font-family: 'AzoSans';
                font-style: normal;
                font-weight: normal;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/AzoSansRegular.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'AzoSans';
                font-style: normal;
                font-weight: medium;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/AzoSansMedium.woff2')}) format('woff2');
            }
            /* Garage Neue */
            @font-face {
                font-family: 'GarageNeue';
                font-style: normal;
                font-weight: 100;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-Thin.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: italic;
                font-weight: 100;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-ThinSlant.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: normal;
                font-weight: 300;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-Light.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: italic;
                font-weight: 300;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-LightSlant.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: normal;
                font-weight: 400;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-Regular.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: italic;
                font-weight: 400;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-RegularSlant.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: normal;
                font-weight: 500;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-Medium.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: italic;
                font-weight: 500;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-MediumSlant.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: normal;
                font-weight: 700;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-Bold.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: italic;
                font-weight: 700;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-BoldSlant.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: normal;
                font-weight: 900;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-Black.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: italic;
                font-weight: 900;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-BlackSlant.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: normal;
                font-weight: 100;
                font-stretch: condensed;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-ThinCondensed.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: italic;
                font-weight: 100;
                font-stretch: condensed;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-ThinCondensedSlant.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: normal;
                font-weight: 300;
                font-stretch: condensed;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-LightCondensed.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: italic;
                font-weight: 300;
                font-stretch: condensed;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-LightCondensedSlant.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: normal;
                font-weight: 400;
                font-stretch: condensed;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-RegularCondensed.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: italic;
                font-weight: 400;
                font-stretch: condensed;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-RegularCondensedSlant.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: normal;
                font-weight: 500;
                font-stretch: condensed;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-MediumCondensed.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: italic;
                font-weight: 500;
                font-stretch: condensed;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-MediumCondensedSlant.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: normal;
                font-weight: 700;
                font-stretch: condensed;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-BoldCondensed.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: italic;
                font-weight: 700;
                font-stretch: condensed;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-BoldCondensedSlant.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: normal;
                font-weight: 900;
                font-stretch: condensed;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-BlackCondensed.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: italic;
                font-weight: 900;
                font-stretch: condensed;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-BlackCondensedSlant.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: normal;
                font-weight: 100;
                font-stretch: expanded;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-ThinExpanded.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: italic;
                font-weight: 100;
                font-stretch: expanded;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-ThinExpandedSlant.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: normal;
                font-weight: 300;
                font-stretch: expanded;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-LightExpanded.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: italic;
                font-weight: 300;
                font-stretch: expanded;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-LightExpandedSlant.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: normal;
                font-weight: 400;
                font-stretch: expanded;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-RegularExpanded.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: italic;
                font-weight: 400;
                font-stretch: expanded;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-RegularExpandedSlant.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: normal;
                font-weight: 500;
                font-stretch: expanded;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-MediumExpanded.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: italic;
                font-weight: 500;
                font-stretch: expanded;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-MediumExpandedSlant.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: normal;
                font-weight: 700;
                font-stretch: expanded;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-BoldExpanded.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: italic;
                font-weight: 700;
                font-stretch: expanded;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-BoldExpandedSlant.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: normal;
                font-weight: 900;
                font-stretch: expanded;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-BlackExpanded.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: italic;
                font-weight: 900;
                font-stretch: expanded;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-BlackExpandedSlant.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: normal;
                font-weight: 100;
                font-stretch: ultra-condensed;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-ThinUltraCondensed.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: italic;
                font-weight: 100;
                font-stretch: ultra-condensed;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-ThinUltraCondensedSlant.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: normal;
                font-weight: 300;
                font-stretch: ultra-condensed;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-LightUltraCondensed.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: italic;
                font-weight: 300;
                font-stretch: ultra-condensed;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-LightUltraCondensedSlant.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: normal;
                font-weight: 400;
                font-stretch: ultra-condensed;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-RegularUltraCondensed.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: italic;
                font-weight: 400;
                font-stretch: ultra-condensed;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-RegularUltraCondensedSlant.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: normal;
                font-weight: 500;
                font-stretch: ultra-condensed;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-MediumUltraCondensed.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: italic;
                font-weight: 500;
                font-stretch: ultra-condensed;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-MediumUltraCondensedSlant.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: normal;
                font-weight: 700;
                font-stretch: ultra-condensed;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-BoldUltraCondensed.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: italic;
                font-weight: 700;
                font-stretch: ultra-condensed;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-BoldUltraCondensedSlant.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: normal;
                font-weight: 900;
                font-stretch: ultra-condensed;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-BlackUltraCondensed.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: italic;
                font-weight: 900;
                font-stretch: ultra-condensed;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-BlackUltraCondensedSlant.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: normal;
                font-weight: 100;
                font-stretch: ultra-expanded;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-ThinUltraExpanded.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: italic;
                font-weight: 100;
                font-stretch: ultra-expanded;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-ThinUltraExpandedSlant.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: normal;
                font-weight: 300;
                font-stretch: ultra-expanded;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-LightUltraExpanded.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: italic;
                font-weight: 300;
                font-stretch: ultra-expanded;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-LightUltraExpandedSlant.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: normal;
                font-weight: 400;
                font-stretch: ultra-expanded;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-RegularUltraExpanded.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: italic;
                font-weight: 400;
                font-stretch: ultra-expanded;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-RegularUltraExpandedSlant.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: normal;
                font-weight: 500;
                font-stretch: ultra-expanded;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-MediumUltraExpanded.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: italic;
                font-weight: 500;
                font-stretch: ultra-expanded;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-MediumUltraExpandedSlant.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: normal;
                font-weight: 700;
                font-stretch: ultra-expanded;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-BoldUltraExpanded.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: italic;
                font-weight: 700;
                font-stretch: ultra-expanded;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-BoldUltraExpandedSlant.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: normal;
                font-weight: 900;
                font-stretch: ultra-expanded;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-BlackUltraExpanded.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'GarageNeue';
                font-style: italic;
                font-weight: 900;
                font-stretch: ultra-expanded;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/GarageNeue-BlackUltraExpandedSlant.woff2')}) format('woff2');
            }
        `}
    />
)

export {LocalFonts}
